import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMyBetsService, placeBetCoinFlipGameService } from 'network/services/flipCoin.service'
import { startFlip } from 'pixi-js-scripts/flip-coin-game/bridge'
import { setPlacedBetsData } from 'redux-thunk/redux/slices/flipCoinGame.slice'
import { setDemoWallet } from 'redux-thunk/redux/slices/gameSetting.slice'
import { triggerBalanceRefresh } from 'hooks/useBalanceSync'

export const placeBetCoinFlip = createAsyncThunk(
  'coin-flip/place-bet-flip-coin-game',
  async (data, thunkApi) => {
    try {
      const res = await placeBetCoinFlipGameService(data)
      data?.onSuccess()
      startFlip()
      thunkApi.dispatch(setPlacedBetsData(res))
      if (data?.isDemoGame) {
        thunkApi.dispatch(setDemoWallet(res?.demoAmount))
      } else {
        triggerBalanceRefresh()
      }
      return res
    } catch (error) {
      data?.onError()
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const getFlipCoinBets = createAsyncThunk(
  'coin-flip/myBets',
  async (data, thunkApi) => {
    try {
      const res = await getMyBetsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
